<template>
  <transition name="fade">
    <div id="modal" class="modal" tabindex="-1" role="dialog" v-if="getModal != null" @mousedown="$store.dispatch('closeModal', $event)">
      <div class="modal-dialog" :class="getModal === 'ModalQuestion' ? 'modal-lg' : ''" role="document">
        <ModalCurrentUser v-if="getModal === 'ModalCurrentUser'"/>
        <ModalUser v-if="getModal === 'ModalUser'"/>
        <ModalStation v-if="getModal === 'ModalStation'"/>
        <ModalPlatform v-if="getModal === 'ModalPlatform'"/>
        <ModalSection v-if="getModal === 'ModalSection'"/>
        <ModalQuestion v-if="getModal === 'ModalQuestion'"/>
        <ModalSetting v-if="getModal === 'ModalSetting'"/>
        <ModalConfirmRemove v-if="getModal === 'ModalConfirmRemove'"/>
      </div>
    </div>
  </transition>
</template>

<script>
  import ModalCurrentUser from './ModalCurrentUser'
  import ModalUser from './ModalUser'
  import ModalStation from './ModalStation'
  import ModalPlatform from './ModalPlatform'
  import ModalSection from './ModalSection'
  import ModalSetting from './ModalSetting'
  import ModalQuestion from './ModalQuestion'
  import ModalConfirmRemove from './ModalConfirmRemove'
  import {mapGetters} from 'vuex'

  export default {
    name: 'Modal',
    components: {
      ModalCurrentUser,
      ModalUser,
      ModalStation,
      ModalPlatform,
      ModalSection,
      ModalSetting,
      ModalQuestion,
      ModalConfirmRemove
    },
    computed: {
      ...mapGetters([
        'getModal',
      ])
    }
  }
</script>

<style lang="scss">
  .modal {
    display: block !important;
    background: #0009 !important;
    overflow: auto !important;

    .modal-header {
      background-color: #f6f6f6;
      color: #242729;
      padding: 20px 30px;
      font-family: Gotham Pro Bold, serif;
      font-size: 14px;
    }
  }
</style>